import React, { useState, useEffect } from "react";
import { Grid, Header, Segment } from "semantic-ui-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import loginImage from "../../../../images/login.jpg";
import VerifyEmail from "../VerifyEmail";
import { DASHBOARD_PATH } from "../../../../constants/paths";
import { useAuth } from "../../../../contexts/AuthContext";
import AuthLayout from "../../../../layouts/AuthLayout";

const VerifyEmailPage = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const initialMode = searchParams.get("mode") || "login";
  const initialOobCode = searchParams.get("oobCode");
  const [mode, setMode] = useState(initialMode);
  const [oobCode] = useState(initialOobCode);
  const navigate = useNavigate();

  const handleModeChange = (newMode) => setMode(newMode);

  useEffect(() => {
    if (user && mode !== "verifyEmail") {
      navigate(DASHBOARD_PATH);
    }
  }, [mode, navigate]);

  return (
    <AuthLayout
      title="Verify Your Email | ArtCollection.io"
      description="Verify your email address to complete your account setup and access all features of ArtCollection.io."
    >
      <Grid
        stackable
        verticalAlign="middle"
        style={{ margin: 0, height: "100vh", backgroundColor: "white" }}
      >
        <Grid.Row centered>
        <Grid.Column computer={8} tablet={12} mobile={16}>
          <Segment style={{ textAlign: "left", padding: 0, margin: 0 }}>
            <div style={{ padding: "3em", margin: 0 }}>
              <Header
                as="h2"
                content="Verify Your Email"
                style={{
                  fontSize: "2em",
                  fontWeight: "bold",
                  lineHeight: "1em",
                  marginTop: "0.5em",
                }}
              />
              {!mode || mode === "verifyEmail" ? (
                <VerifyEmail
                  oobCode={oobCode}
                  onChangeMode={handleModeChange}
                />
              ) : null}
            </div>
          </Segment>
        </Grid.Column>
        </Grid.Row>
      </Grid>
    </AuthLayout>
  );
};

export default VerifyEmailPage;
